import React from "react";
import { Container } from "reactstrap";
import VVSTable from "components/form-control/VVSTable";

export default function PendingContract() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <VVSTable
            title="Hợp đồng đang xử lý"
            name="Contract"
            disableAdd
            whereQuery={{
              status: "pending",
            }}
          />
        </Container>
      </div>
    </React.Fragment>
  );
}
